export enum CapabilityType {
  Teacher = 'Teacher',
  Student = 'Student',
  Classroom = 'Classroom',
  Admin = 'Admin',
  Parent = 'Parent',
}
